import React from 'react';
import { TRIP_TYPES } from '../../../lib/constants/bookingForm';
import styles from '../../../styles/components/forms/BookingForm.module.css';

const TripDetailsSection = ({ 
    formData, 
    errors, 
    isClicked, 
    isDarkMode, 
    onInputChange, 
    onClearError,
    getInputClassName 
}) => {
    return (
        <>
            {/* Trip Type */}
            <div className="col-lg-6">
                <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                    <div className="d-flex flex-column">
                        <label htmlFor="tripType" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                            Trip Type <span className="text-danger">*</span>
                        </label>
                        <select
                            id="tripType"
                            name="tripType"
                            className={getInputClassName('tripType')}
                            value={formData.tripType}
                            onChange={e => {
                                onInputChange('tripType', e.target.value);
                                onClearError('tripType');
                            }}
                            style={{ height: '42px' }}>
                            <option value="">Select Trip Type</option>
                            {TRIP_TYPES.map(type => (
                                <option key={type.id} value={type.id} disabled={type.disabled}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                        {errors.tripType && (
                            <div
                                className={`text-danger ${styles['error-message-container']}`}
                                style={{ minHeight: '20px' }}>
                                {errors.tripType}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Passengers */}
            <div className="col-lg-6">
                <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                    <div className="d-flex flex-column">
                        <label htmlFor="passengers" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                            Passengers <span className="text-danger">*</span>
                        </label>
                        <input
                            className={getInputClassName('noOfPassengers')}
                            type="number"
                            min="1"
                            max="99"
                            step="1"
                            placeholder="No. of Passengers"
                            value={formData.noOfPassengers}
                            onChange={e => {
                                const value = e.target.value;
                                // Only allow numbers and ensure length is max 2
                                if (/^\d*$/.test(value) && value.length <= 2) {
                                    onInputChange('noOfPassengers', value);
                                    onClearError('noOfPassengers');
                                }
                            }}
                            onKeyDown={e => {
                                // Prevent non-numeric keys except backspace, delete, arrow keys, tab, enter
                                const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter'];
                                const isNumber = /^\d$/.test(e.key);
                                const isAllowedKey = allowedKeys.includes(e.key);
                                const isCtrlOrCmd = e.ctrlKey || e.metaKey;
                                
                                if (!isNumber && !isAllowedKey && !isCtrlOrCmd) {
                                    e.preventDefault();
                                }
                            }}
                            onInput={e => {
                                // Additional Safari-specific validation
                                const value = e.target.value;
                                if (value && (isNaN(value) || value < 1 || value > 99)) {
                                    e.target.value = formData.noOfPassengers || '';
                                }
                            }}
                        />
                        {errors.noOfPassengers && (
                            <div
                                className={`text-danger ${styles['error-message-container']}`}
                                style={{ minHeight: '20px' }}>
                                {errors.noOfPassengers}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TripDetailsSection;
